export const LUZU_FOLDER_NAMES = {
  'luzu/NDN/clipping': 'NDN Clipping'
} as const;
